'use client';
import {
  ConversationBackground,
  ConversationHeader,
  MessageList,
  ConversationMessageInput,
  IConversationSet,
} from '@ui/components';
import { useMessageContext } from '../../message/message.context';
import { useEffect, useRef } from 'react';

interface Props {
  conversationSet: IConversationSet | null;
  onReadNewMessage: (conversation: IConversationSet) => void;
  singleConversationSet?: IConversationSet | null;
}
export const ConversationMessagesPane = ({
  conversationSet,
  onReadNewMessage,
  singleConversationSet,
}: Props) => {
  const messageState = useMessageContext('creator');
  const hasMarkedAsReadRef = useRef(false);

  // Clear reply and edit state when switching conversations
  useEffect(() => {
    if (!conversationSet?.conversation?.id) return;

    messageState.setReplyToMessage?.(null);
    messageState.setMessageToEdit?.(null);
    hasMarkedAsReadRef.current = false;
  }, [conversationSet?.conversation?.id]);

  useEffect(() => {
    if (!conversationSet?.conversation?.id || hasMarkedAsReadRef.current) return;

    const timer = setTimeout(() => {
      onReadNewMessage(conversationSet);
      hasMarkedAsReadRef.current = true;
    }, 2000);

    return () => clearTimeout(timer);
  }, [conversationSet, onReadNewMessage]);

  return (
    <ConversationBackground>
      <div className="relative flex h-full flex-col overflow-hidden">
        <ConversationHeader />
        {conversationSet && (
          <MessageList
            className="flex-grow overflow-y-auto p-4"
            contextUserType="creator"
            restrictions={conversationSet.restrictions_list}
            conversationSet={conversationSet}
            singleConversationSet={singleConversationSet}
            onReadNewMessage={onReadNewMessage}
            messageDescriptionClassName="max-w-[350px]"
          />
        )}
        <div className="flex-shrink-0">
          <ConversationMessageInput />
        </div>
      </div>
    </ConversationBackground>
  );
};
